import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Kicker, H2 } from './ui/Typography';
export function EmpathySection() {
  return <Section hasOrb={false} data-id="element-32">
      <div className="max-w-3xl" data-id="element-33">
        <Kicker data-id="element-34">IF YOU'VE FELT THIS</Kicker>
        <H2 data-id="element-35">YOU'RE NOT BEHIND. YOU'RE JUST MISSING THE SYSTEM.</H2>

        <div className="space-y-6 text-lg sm:text-xl text-ink-dim leading-relaxed" data-id="element-36">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-37">
            You've watched three friends mention ChatGPT this month. You've
            tried it, it felt like a toy. You closed the tab.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-38">
            You keep seeing posts about "making $10K/mo with AI" and rolling
            your eyes. Rightly so. Most of it is hype.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-ink font-medium" data-id="element-39">
            But you also know the opportunity is real, and the people actually
            making money with AI aren't the loudest ones online.
          </motion.p>
        </div>
      </div>
    </Section>;
}